import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var TableContainer = /*#__PURE__*/ styled("table", {
    target: "e1cu52w20"
})("width:100%;margin-bottom:1rem;border:1px solid ", Theme.Color.natural50, ";");
var TableHead = /*#__PURE__*/ styled("thead", {
    target: "e1cu52w21"
})("background-color:", Theme.Color.primary, ";");
var Row = /*#__PURE__*/ styled("tr", {
    target: "e1cu52w22"
})("height:3rem;");
var ColumnHead = /*#__PURE__*/ styled("th", {
    target: "e1cu52w23"
})("padding:0.3125rem 0.625rem;font-weight:bold;text-align:left;color:", Theme.Color.natural0, ";");
var Cell = /*#__PURE__*/ styled("td", {
    target: "e1cu52w24"
})("padding:0.3125rem 0.625rem;");
export { Cell, ColumnHead, Row, TableContainer, TableHead };
